import * as React from 'react'

interface IconProps {
  color?: string
  style?: React.CSSProperties
}

const DuplicateIcon = ({ style, color = '#A4A4A4' }: IconProps) => {
  return (
    <svg style={style} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_9424_72470)'>
        <path
          d='M6.90764 11.3744C4.38005 11.3744 1.86997 9.60108 0.36322 7.94208C-0.12153 7.40367 -0.12153 6.59342 0.362054 6.05675C1.86939 4.39717 4.38239 2.625 6.91522 2.625C6.94497 2.625 6.97355 2.625 7.0033 2.62558C7.0278 2.625 7.05989 2.625 7.09255 2.625C9.61722 2.625 12.1291 4.39717 13.637 6.05558C14.1217 6.594 14.1223 7.40425 13.6381 7.9415C12.1296 9.60167 9.61489 11.375 7.07855 11.375L6.99164 11.3744H6.90764ZM6.91405 3.49942C4.66764 3.49942 2.39147 5.12342 1.01072 6.64358C0.82872 6.84542 0.82872 7.15167 1.01189 7.35525C2.39205 8.87483 4.66764 10.4994 6.91522 10.4994L6.99164 10.4988L7.07097 10.4994C9.32672 10.4994 11.607 8.87483 12.9889 7.35408C13.1709 7.15225 13.1709 6.846 12.9877 6.64242C11.6064 5.12342 9.32905 3.5 7.08264 3.5C7.08264 3.5 6.9928 3.50058 6.99164 3.50058L6.91405 3.49942Z'
          fill={color}
        />
        <path
          d='M6.99844 9.62402C6.29727 9.62402 5.63811 9.35044 5.14227 8.85461C4.64644 8.35877 4.37344 7.69961 4.37402 6.99844C4.37402 5.55119 5.55177 4.37402 6.99902 4.37402C7.70019 4.37402 8.35936 4.64702 8.85519 5.14227C9.35102 5.63811 9.62402 6.29669 9.62402 6.99786C9.62402 7.70136 9.35044 8.35994 8.85461 8.85577C8.35877 9.35102 7.70019 9.62402 6.99902 9.62402H6.99844ZM6.99961 5.24902C6.03477 5.24902 5.24961 6.03361 5.24961 6.99844C5.24961 7.46569 5.43161 7.90552 5.76177 8.23569C6.09252 8.56644 6.53177 8.74844 6.99902 8.74844C7.46686 8.74844 7.90611 8.56644 8.23627 8.23627C8.56644 7.90611 8.74902 7.46627 8.74902 6.99902C8.74902 6.53002 8.56702 6.09077 8.23627 5.76061C7.90611 5.43102 7.46686 5.24902 6.99961 5.24902Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_9424_72470'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DuplicateIcon
